import { render } from "./ContractorsSync.vue?vue&type=template&id=27bd40af&scoped=true"
import script from "./ContractorsSync.vue?vue&type=script&lang=js"
export * from "./ContractorsSync.vue?vue&type=script&lang=js"

import "./ContractorsSync.vue?vue&type=style&index=0&id=27bd40af&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bd40af"]])

export default __exports__